import React from 'react';
import { motion } from 'framer-motion';
export function Author() {
  return <section className="bg-surface py-[40px] md:py-[64px] px-6" data-id="element-17">
      <div className="max-w-[860px] mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-surface rounded-xl aspect-[3/4] overflow-hidden shadow-lg" data-id="element-19">
          <video src="https://cdn.magicpatterns.com/uploads/jR6G7ZifyKVVaFxdbQUbEL/Roderic-Oficina - 4.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-20" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-21">
          <p className="font-mono text-[11px] tracking-[0.15em] text-cocoa uppercase mb-6" data-id="element-22">
            EL AUTOR
          </p>

          <h2 className="font-serif font-bold text-[38px] leading-[1.2] text-text-primary mb-6" data-id="element-23">
            Roderic Guillen — Sobreviviente de 6 bypass coronarios.
          </h2>

          <p className="text-[18px] leading-[1.8] text-text-secondary mb-8" data-id="element-24">
            Después de sobrevivir a 6 bypass coronarios, convirtió su
            experiencia en una misión: explicar en español claro lo que muchos
            médicos nunca tienen tiempo de detallar. Como fundador de GoDeskCore
            y Heartbeat, hoy traduce la ciencia médica compleja en información
            práctica para familias latinas.
          </p>

          <blockquote className="border-l-[3px] border-cocoa pl-6 py-2" data-id="element-25">
            <p className="font-serif italic text-[22px] leading-[1.5] text-text-primary" data-id="element-26">
              Si hubiera tenido este libro 20 años antes, no habría necesitado 6
              bypass.
            </p>
          </blockquote>
        </motion.div>
      </div>
    </section>;
}